/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next birthday`)
};

const es_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo cumpleaños`)
};

const de_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Geburtstag`)
};

const nl_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende verjaardag`)
};

const fr_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochain anniversaire`)
};

const it_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo compleanno`)
};

const pt_br2_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo aniversário`)
};

const pt_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo aniversário`)
};

const ja_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の誕生日`)
};

const zh_age_next_birthday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个生日`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_next_birthday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_next_birthday(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_next_birthday", locale)
	if (locale === "en") return en_age_next_birthday(inputs)
	if (locale === "es") return es_age_next_birthday(inputs)
	if (locale === "de") return de_age_next_birthday(inputs)
	if (locale === "nl") return nl_age_next_birthday(inputs)
	if (locale === "fr") return fr_age_next_birthday(inputs)
	if (locale === "it") return it_age_next_birthday(inputs)
	if (locale === "pt-BR") return pt_br2_age_next_birthday(inputs)
	if (locale === "pt") return pt_age_next_birthday(inputs)
	if (locale === "ja") return ja_age_next_birthday(inputs)
	return zh_age_next_birthday(inputs)
};